import { Controller } from "@hotwired/stimulus";

const MAX_ROWS = 30;

export default class UserRoleOverridesController extends Controller {
  static targets = ["list", "row", "json"];
  static values = {
    placeholderUser: String,
    placeholderRoles: String,
    labelTemporary: String,
    ariaRemove: String,
  };

  connect() {
    this.#serialize();
  }

  addRow() {
    if (this.rowTargets.length >= MAX_ROWS) return;

    const row = document.createElement("div");
    row.className = "flex items-center gap-2 mb-2";
    row.dataset.userRoleOverridesTarget = "row";
    row.innerHTML = `
      <input type="text" class="input input-bordered input-xs w-36 font-mono"
             data-field="user_id"
             data-action="input->user-role-overrides#onChange">
      <input type="text" class="input input-bordered input-xs flex-1 font-mono"
             data-field="role_ids"
             data-action="input->user-role-overrides#onChange">
      <label class="flex items-center gap-1 text-xs cursor-pointer shrink-0">
        <input type="checkbox" class="checkbox checkbox-xs" data-field="remove_after_join"
               data-action="change->user-role-overrides#onChange">
      </label>
      <button type="button"
              class="btn btn-ghost btn-xs btn-square text-error/70 hover:text-error shrink-0"
              data-action="click->user-role-overrides#removeRow">
        <i class="fa-solid fa-trash-can"></i>
      </button>
    `;
    const [userInput, rolesInput] = row.querySelectorAll("input[type='text']");
    userInput.placeholder = this.placeholderUserValue;
    rolesInput.placeholder = this.placeholderRolesValue;
    row.querySelector("label").appendChild(document.createTextNode(this.labelTemporaryValue));
    row.querySelector("button").setAttribute("aria-label", this.ariaRemoveValue);
    this.listTarget.appendChild(row);
    userInput.focus();
    this.#serialize();
  }

  removeRow(event) {
    event.currentTarget.closest("[data-user-role-overrides-target='row']")?.remove();
    this.#serialize();
  }

  onChange() {
    this.#serialize();
  }

  #serialize() {
    const overrides = this.rowTargets
      .map((row) => ({
        user_id: row.querySelector("[data-field='user_id']")?.value?.trim() || "",
        role_ids: row.querySelector("[data-field='role_ids']")?.value?.trim() || "",
        remove_after_join: row.querySelector("[data-field='remove_after_join']")?.checked || false,
      }))
      .filter((o) => o.user_id);

    if (this.hasJsonTarget) {
      this.jsonTarget.value = JSON.stringify(overrides);
    }
  }
}
